import React from "react";
import { formatPoilcyDate } from "../../../shared/dateFormat";
export const DiaryListColumns = () => {
  return [
    {
      key: "location",
      name: "location",
      label: "Record No.",
    },
    {
      key: "endTime",
      name: "endTime",
      label: "Date",
      options: {
        customBodyRender: (value) => {
          return <span> {formatPoilcyDate(value)}</span>;
        },
      },
    },

    {
      key: "description",
      name: "description",
      label: "Notes",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="columnElipsis" title={value}>
              {value}
            </div>
          );
        },
        sort: false,
      },
    },
  ];
};
